import { createSlice } from '@reduxjs/toolkit';
import { getJobDefinitionParameters } from 'ducks/job-definition-parameters/operators';
import { Slices } from 'ducks/slices';
import { ProjectParameters } from 'ducks/types/store-types';
import { normalizeParameters } from 'ducks/utils';

const initialState: ProjectParameters = [];

const jobDefinitionParametersSlice = createSlice({
  name: Slices.JOB_DEFINITION_PARAMETERS,
  initialState,
  reducers: {
    clearParameters: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getJobDefinitionParameters.pending, () => {
        return initialState;
      })
      .addCase(getJobDefinitionParameters.fulfilled, (_, { payload }) => {
        return normalizeParameters(payload);
      })
      .addCase(getJobDefinitionParameters.rejected, () => {
        return initialState;
      });
  },
});

export const { clearParameters } = jobDefinitionParametersSlice.actions;

export default jobDefinitionParametersSlice.reducer;
